import {ThemeType} from '../../../theme';
import {BasePaddingPxProps} from '../../base/types';
import {ThemePaddingPxProps} from '../../types';

export const mapPaddingToBaseProperties = (
  theme: ThemeType,
  {
    padding,
    paddingHorizontal,
    paddingVertical,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
  }: ThemePaddingPxProps,
): BasePaddingPxProps => ({
  // Padding
  padding: padding ? theme.spacing[padding] : undefined,
  paddingHorizontal: paddingHorizontal
    ? theme.spacing[paddingHorizontal]
    : undefined,
  paddingVertical: paddingVertical ? theme.spacing[paddingVertical] : undefined,
  paddingTop: paddingTop ? theme.spacing[paddingTop] : undefined,
  paddingBottom: paddingBottom ? theme.spacing[paddingBottom] : undefined,
  paddingLeft: paddingLeft ? theme.spacing[paddingLeft] : undefined,
  paddingRight: paddingRight ? theme.spacing[paddingRight] : undefined,
});
